// @flow
import Window from '../Window';

const isDev = Window.isDev();

export const GDevelopGamePreviews = {
  baseUrl: isDev
    ? `https://game-previews-dev.gdevelop.io/`
    : '/proxy/game-previews',
};

export const GDevelopGamesPlatform = {
  getInstantBuildUrl: (buildId: string) =>
    isDev
      ? `https://gd.games/instant-builds/${buildId}?dev=true`
      : `https://gd.games/instant-builds/${buildId}`,
  getGameUrl: (gameId: string) =>
    isDev
      ? `https://gd.games/games/${gameId}?dev=true`
      : `https://gd.games/games/${gameId}`,
  getGameUrlWithSlug: (userSlug: string, gameSlug: string) =>
    isDev
      ? `https://gd.games/${userSlug.toLowerCase()}/${gameSlug.toLowerCase()}?dev=true`
      : `https://gd.games/${userSlug.toLowerCase()}/${gameSlug.toLowerCase()}`,
  getUserPublicProfileUrl: (userId: string, username: ?string) =>
    username
      ? `https://gd.games/${username}${isDev ? '?dev=true' : ''}`
      : `https://gd.games/user/${userId}${isDev ? '?dev=true' : ''}`,
};

export const GDevelopFirebaseConfig = {
  apiKey: 'AIzaSyAnX9QMacrIl3yo4zkVFEVhDppGVDDewBc',
  authDomain: 'gdevelop-services.firebaseapp.com',
  databaseURL: 'https://gdevelop-services.firebaseio.com',
  projectId: 'gdevelop-services',
  storageBucket: 'gdevelop-services.appspot.com',
  messagingSenderId: '44882707384',
};

export const GDevelopAuthorizationWebSocketApi = {
  baseUrl: isDev
    ? 'wss://api-ws-dev.gdevelop.io/authorization'
    : 'wss://api-ws.gdevelop.io/authorization',
};

export const GDevelopBuildApi = {
  baseUrl: isDev
    ? 'https://api-dev.gdevelop.io/build'
    : '/proxy/api/build',
};

export const GDevelopUsageApi = {
  baseUrl: isDev
    ? 'https://api-dev.gdevelop.io/usage'
    : '/proxy/api/usage',
};

export const GDevelopReleaseApi = {
  baseUrl: isDev
    ? 'https://api-dev.gdevelop.io/release'
    : '/proxy/api/release',
};

export const GDevelopAssetApi = {
  baseUrl: isDev
    ? 'https://api-dev.gdevelop.io/asset'
    : '/proxy/api/asset',
};

export const GDevelopAssetCdn = {
  baseUrl: {
    staging: 'https://resources.gdevelop-app.com/staging/assets-database',
    live: 'https://resources.gdevelop-app.com/assets-database',
  },
};

export const GDevelopAnalyticsApi = {
  baseUrl: isDev
    ? 'https://api-dev.gdevelop.io/analytics'
    : '/proxy/api/analytics',
};

export const GDevelopGameApi = {
  baseUrl: isDev
    ? 'https://api-dev.gdevelop.io/game'
    : '/proxy/api/game',
};

export const GDevelopUserApi = {
  baseUrl: isDev
    ? 'https://api-dev.gdevelop.io/user'
    : '/proxy/api/user',
};

export const GDevelopPlayApi = {
  baseUrl: isDev
    ? 'https://api-dev.gdevelop.io/play'
    : '/proxy/api/play',
};

export const GDevelopShopApi = {
  baseUrl: isDev
    ? 'https://api-dev.gdevelop.io/shop'
    : '/proxy/api/shop',
};

export const GDevelopProjectApi = {
  baseUrl: isDev
    ? 'https://api-dev.gdevelop.io/project'
    : '/proxy/api/project',
};

export const GDevelopGenerationApi = {
  baseUrl: isDev
    ? 'https://api-dev.gdevelop.io/generation'
    : '/proxy/api/generation',
};

export const GDevelopProjectResourcesStorage = {
  baseUrl: isDev
    ? 'https://project-resources-dev.gdevelop.io'
    : '/proxy/project-resources',
};

export const GDevelopPrivateAssetsStorage = {
  baseUrl: isDev
    ? 'https://private-assets-dev.gdevelop.io'
    : '/proxy/private-assets',
};

export const GDevelopPrivateGameTemplatesStorage = {
  baseUrl: isDev
    ? 'https://private-game-templates-dev.gdevelop.io'
    : '/proxy/private-game-templates',
};

export const GDevelopPublicAssetResourcesStorageBaseUrl =
  '/proxy/asset-resources';
export const GDevelopPublicAssetResourcesStorageStagingBaseUrl =
  '/proxy/asset-resources/staging';
